import { useQuery } from "@tanstack/react-query";

import { ADMIN_ANEEL_TARIFFS_ENDPOINTS, AdminAneelTariffs } from "@/service/api/admin-aneel-tariffs";
import useToastOnError from "@/modules/common/hooks/useToastOnError";

const useAneelTariffLastUpdate = () => {
  const query = useQuery({
    queryKey: [ADMIN_ANEEL_TARIFFS_ENDPOINTS.GET_LAST_UPDATE],
    queryFn: () => AdminAneelTariffs.getLastUpdate(),
    retry: false,
  });

  useToastOnError(query.isError, query.error, "Erro ao carregar última atualização das tarifas.");

  return query;
};

export default useAneelTariffLastUpdate;
